import { type Dispatch, useState } from "react";

/**
 * @deprecated Use the useModalState hook from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) instead.
 */
// eslint-disable-next-line no-restricted-syntax
export enum ModalStatus {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
}

/**
 * @deprecated Use the useModalState hook from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) instead.
 */
export interface UseModalState {
  modalStatus: ModalStatus;
  setModalStatus: Dispatch<ModalStatus>;
  modalIsClosed: boolean;
  modalIsOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

/**
 * @deprecated Use the useModalState hook from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) instead.
 */
export function useModalState(initialModalStatus = ModalStatus.CLOSED): UseModalState {
  const [modalStatus, setModalStatus] = useState(initialModalStatus);
  function openModal() {
    setModalStatus(ModalStatus.OPEN);
  }

  function closeModal() {
    setModalStatus(ModalStatus.CLOSED);
  }

  return {
    modalStatus,
    setModalStatus,
    modalIsClosed: modalStatus === ModalStatus.CLOSED,
    modalIsOpen: modalStatus === ModalStatus.OPEN,
    openModal,
    closeModal,
  };
}
